import React from "react";
import { dateFormator } from "../../../../utils";

const InvoiceHeader = ({
  data = {},
  // color = "primary",
  color = "blueinvoice-header",
  type = "main", // main, sub
}) => {
  return data?.company ? (
    type === "main" ? (
      <div
        className={`header-main bg-${color} text-white flex justify-between items-end px-5  pt-5 `}
      >
        <div className="w-[200px] bg-white/10 rounded-t-xl p-4">
          <img src={data?.company?.companyLogo} alt={data?.company?.name} />
        </div>
        {data?.invoiceDeta?.dueTotal && (
          <div className="pb-1">
            <h6>Total Due:</h6>
            <h4>
              {data?.invoiceDeta?.dueTotal?.toFixed(2)}{" "}
              {data?.invoiceDeta?.currency}
            </h4>
          </div>
        )}
      </div>
    ) : (
      <div className="header-main bg-gray-50  text-gray-300 py-2 px-5 text-sm text-start">
        {data?.company?.name}
      </div>
    )
  ) : type === "main" ? (
    <div className="header-main bg-gray-50 text-center text-gray-300 py-2 px-5">
      Header
    </div>
  ) : (
    <div className="header-main bg-gray-50  text-gray-300 py-2 px-5 text-sm text-start">
      {dateFormator(new Date(), "day-shortMonth-year-time-utc")}
    </div>
  );
};

export default InvoiceHeader;
